export default __webpack_public_path__ + "static/icon-24-2-94da0ccfcf46d60ef1bfaff2269f9ea3.png";